/**
 * The idle lock (spec 15.3): ten minutes without input lock an unlocked session, on every
 * screen of it: the shell, a step the API asked for mid-session (/masuk/dua-langkah with its QR
 * code and secret, /masuk/sandi-awal), the offer after a recovery, the first download. It reads
 * no route, only whether the session is open. Never away from unsaved work: while anything on
 * screen is not saved (a form, a figure; app/store/belumDisimpan) the check keeps running and
 * locks as soon as it is. The session opening (the PIN, a sign-in) starts the ten minutes.
 * While unsaved work holds it past the ten minutes it says so once per idle period
 * (`tertahan`, ./diamTertahan): what is secret on screen closes then (a shown password is
 * masked again, an initial password typed for someone else is emptied), the work stays.
 * DOM-free so the tests drive it with a clock; ./kunciDiamTab wires it to the window, which
 * ./app does once for the tab's life.
 */
import { IDLE_LOCK_MS } from './pin'

export interface KunciDiamDeps {
  now(): number
  /** The session is unlocked (`status === 'aktif'`). */
  aktif(): boolean
  /** Something on screen is not saved yet (a form, a figure). */
  kotor(): boolean
  kunci(): void
  /** Idle past the limit but held by unsaved work: once per idle period. */
  tertahan?(): void
}

export interface KunciDiam {
  /** Input: a key, a pointer, a wheel. */
  sentuh(): void
  /** The session opened or closed (the store's status); opening starts the ten minutes. */
  sesiBerubah(aktif: boolean): void
  /**
   * Locks an open session idle for ten minutes, unless a form holds unsaved changes; then
   * says it is held (`tertahan`), the first time in this idle period.
   */
  periksa(): void
}

export function buatKunciDiam(d: KunciDiamDeps): KunciDiam {
  let terakhir = d.now()
  let terbuka = d.aktif()
  // Said for this idle period already: input or the session opening starts a new one.
  let disampaikan = false
  const mulai = () => {
    terakhir = d.now()
    disampaikan = false
  }
  return {
    sentuh: mulai,
    sesiBerubah(aktif) {
      if (aktif && !terbuka) mulai()
      terbuka = aktif
    },
    periksa() {
      if (!d.aktif()) return
      if (d.now() - terakhir < IDLE_LOCK_MS) return
      if (d.kotor()) {
        if (disampaikan) return
        disampaikan = true
        d.tertahan?.()
        return
      }
      d.kunci()
    },
  }
}
